import React from "react";
import styled from "styled-components";
import CatGeneratorLevel3 from "./CatGeneratorLevel3";
import LevelThirdTable from "./LevelThirdTable";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import { useRecoilState } from "recoil";
import { ContentUnitModal } from "../../../../shared/content-unit";
import DeleteLevel3 from "../../../Dialog/contentUnit/productCategory/DeleteLevel3";
import Editlevel3 from "../../../Dialog/contentUnit/productCategory/EditLevel3";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

function LevelThid() {
  const [modualsContent, setModuals] = useRecoilState(ContentUnitModal);

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="دسته بندی محصولات"
        num3="سطح سوم"
        href1="/dashboard/content-controller"
        href2="/dashboard/productCategory"
      />
      <LevelThirdStyle>
        {modualsContent.deleteLevel3.isShow && (
          <DeleteLevel3
            show={modualsContent.deleteLevel3.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                deleteLevel3: {
                  ...modualsContent.deleteLevel3,
                  isShow: false,
                },
              })
            }
          />
        )}
        {modualsContent.updateLevel3.isShow && (
          <Editlevel3
            show={modualsContent.updateLevel3.isShow}
            handleClose={() =>
              setModuals({
                ...modualsContent,
                updateLevel3: {
                  ...modualsContent.updateLevel3,
                  isShow: false,
                },
              })
            }
          />
        )}
        <Toggle title={"افزودن به سطح سوم"}>
          <CatGeneratorLevel3 />
        </Toggle>
        <LevelThirdTable />
      </LevelThirdStyle>
    </>
  );
}

const LevelThirdStyle = styled.div``;

export default LevelThid;
